export class ContactRequest {
  phone: string;
  platformId: string;//
}
